module.exports = __webpack_public_path__ + "img/basket.44a83e1b.svg";